import React, { ForwardedRef, forwardRef } from 'react';

import SearchInput, { SearchInputProps } from './SearchInput';

export default forwardRef((props: SearchInputProps, ref: ForwardedRef<HTMLInputElement>) => <SearchInput {...props} forwardedRef={ref} />);
